<template>
  <div id="messagePushing" style="padding-bottom: 20px">
    <div>
      <div class="messagePushingStep">
        Step 1.选择消息模板
      </div>
      <div style="margin-left: 35px">
        <allSelect @on-change="changeMuban" :chooseData="messageList" :needReturn="'templateId'" :placeholder="'请选择内容分类'" :matchValue="'name'" :showValue="'{{name}}'" v-model="postMessageModel.templateId">
        </allSelect>
      </div>
    </div>
    <div>
      <div class="messagePushingStep">
        Step 2.输入模板消息内容
      </div>
      <div style="margin-left: 35px;width: 60%">
        <div :key="index" v-for="(item, index) in postMessageModel.items" class="d_flex m_t_10">
          <div v-if="item.displayName" class="w20 t_l">{{ item.displayName }}</div>
          <input class="allInput w80" :placeholder="(item.displayName && item.displayName.replace(':', '').replace('：', '')) || '请输入内容'" type="text" style="" v-model="item.value">
        </div>
        <div class="d_flex m_t_10">
          <div class="w20 t_l">url:</div>
          <input class="allInput w80" placeholder="请输入内容url" @blur="checkUrl" type="text" style="" v-model="postMessageModel.url">
        </div>
        <div class="c_999 m_t_5" v-if="isLimitCheck">
          *系统将自动过滤已经提交调研的用户
        </div>
      </div>
    </div>
    <div>
      <div class="messagePushingStep">
        Step 3.选择人员
      </div>
      <div class="m_t_10" style="margin-left: 15px">
        <div class="w20 split_2">
          <div :class="isHCP ? 'messagePushTabActive' : ''" @click="switchHCP(1)" class="p_t_b_5 b_t_r_10 border_dede t_c" style="font-size: 14px;">HCP</div>
          <div :class="isHCP ? '' : 'messagePushTabActive'" @click="switchHCP(0)" class="p_t_b_5 b_t_r_10 border_dede t_c" style="font-size: 14px;margin-left: -15px;border-left: none;">员工</div>
        </div>
        <div v-if="isHCP" class="d_flex" style="display: inline-block;vertical-align: top;width:calc(100% - 250px);">
          <div class="border_dede messagePushTabRadius allSearch w100 d_i" style="padding-top: 20px;margin: 0;height: 600px;overflow: hidden;">
            <div class="newSearch d_flex" style="margin: 0 20px;">
              <div style="width: auto;white-space: normal">
                <p>
                  <input @keyup.enter="getList(1)" class="allInput m_r_10 " placeholder="姓名" type="text" style="" v-model="postData.name">
                </p>
                <p><input @keyup.enter="getList(1)" class="allInput m_r_10 " placeholder="城市" type="text" style="" v-model="postData.City"></p>
                <p><input @keyup.enter="getList(1)" class="allInput m_r_10 " placeholder="医院" type="text" style="" v-model="postData.Hospital"></p>
                <p><input @keyup.enter="getList(1)" class="allInput m_r_10 " placeholder="科室" type="text" style="" v-model="postData.dept"></p>
<!--                <p>-->
<!--                  <abbr class="d_i">-->
<!--                    <allSelect :chooseData="departList" :needSearch="true" :needReturn="'nameId'" :placeholder="'科室'" :matchValue="'description'" :showValue="'{{description}}'" v-model="postData.dept">-->
<!--                    </allSelect>-->
<!--                  </abbr>-->
<!--                </p>-->
                <p>
                  <abbr style="margin-right: 11px" class="d_i">
                    <allSelect :chooseData="fieldsList"  v-on:on-change="changeField" :needReturn="'id'" :placeholder="'请选择领域'" :matchValue="'name'" :showValue="'{{name}}'" v-model="postData.FieldId">
                    </allSelect>
                  </abbr>
                </p>
                <p>
                  <abbr style="margin-right: 11px" class="d_i">
                    <allSelect :chooseData="indicationsList" :needReturn="'id'" :placeholder="'请选择适应症'" :matchValue="'name'" :showValue="'{{name}}'" v-model="postData.IndicationId">
                    </allSelect>
                  </abbr>
                </p>
                <button style="" class="redButton " @click="getList(1)">搜索</button>
              </div>
            </div>
            <div class="allTablePlace d_i" style="vertical-align: top;width: calc(100% - 30px)">
              <div style="height: 400px;overflow: auto;">
                <table cellspacing="0" class="allTable">
                  <thead style="background-color: rgba(240,240,240,0.3);">
                  <tr class="table_th_bottom">
                    <th width="5%">
                      <input @change="chooseAllData" v-model="selectAll" type="checkbox" class="allCheckbox" id="ALLchecked" name="checked"/>
                      <label for="ALLchecked"></label>
                    </th>
                    <th>姓名</th>
                    <th>省份</th>
                    <th>城市</th>
                    <th>医院</th>
                    <th>科室</th>
                    <th>领域</th>
                    <th>适应症</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr :key="index" v-for="(item, index) in userList">
                    <td width="5%">
                      <input @change="chooseUserInfo(item)" v-model="item.checked" type="checkbox" :disabled="isLimitCheck && haveDomeSurveyList.indexOf(item.openId) > -1" class="allCheckbox" :id="'userChecked' + index" name="checked"/>
                      <label :for="'userChecked' + index"></label>
                    </td>
                    <td width="20%" class="NoWrap" style="max-width: 100px" :title="item.docName">{{item.name}}</td>
                    <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.province">{{item.province}}</td>
                    <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.city">{{item.city}}</td>
                    <td width="" class="NoWrap" :title="item.instName">{{item.hospital}}</td>
                    <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.dept">{{item.dept}}</td>
                    <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.fields">{{item.fields}}</td>
                    <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.indications">{{item.indications}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <page v-if="totalPage !== 0" :needPageSize="true" :pageSize="postData.PageSize" :totalCount="totalCount" v-on:on-getList="getList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
            </div>
          </div>
        </div>
        <div v-if="!isHCP" style="display: inline-block;vertical-align: top;width:calc(100% - 250px);">
          <div class="border_dede messagePushTabRadius allSearch w100 d_i p_r" style="padding-top: 20px;margin: 0;height: 600px;overflow: hidden;">
            <div class="newSearch d_flex" style="margin: 0 20px;">
              <div style="width: auto;white-space: normal">
                <p><input @keyup.enter="getAll(1)" class="allInput" type="text" placeholder="姓名" v-model="postDataEmp.Name"></p>
                <p><input @keyup.enter="getAll(1)" class="allInput" type="text" placeholder="邮箱" v-model="postDataEmp.Email"></p>
                <p><button class="redButton" @click="getAll(1)">搜索</button></p>
              </div>
            </div>
            <div class="allTablePlace d_i" style="vertical-align: top;width: calc(100% - 30px)">
              <div style="height: 400px;overflow: auto;">
                <table cellspacing="0" class="allTable" style="width: 100%">
                  <thead style="background-color: rgba(240,240,240,0.3);">
                  <tr class="table_th_bottom">
                    <th width="5%">
                      <input @change="chooseAllData" v-model="selectAll" type="checkbox" class="allCheckbox" id="ALLchecked" name="checked"/>
                      <label for="ALLchecked"></label>
                    </th>
                    <th>姓名</th>
                    <th>邮箱</th>
<!--                    <th>openId</th>-->
                  </tr>
                  </thead>
                  <tbody>
                  <tr :key="index" v-for="(item, index) in userList">
                    <td width="5%">
                      <input @change="chooseUserInfo(item)" v-model="item.checked" :disabled="isLimitCheck && haveDomeSurveyList.indexOf(item.openId) > -1" type="checkbox" class="allCheckbox" :id="'userChecked' + index" name="checked"/>
                      <label :for="'userChecked' + index"></label>
                    </td>
                    <td width="20%">{{item.name}}</td>
                    <td width="30%">{{item.email}}</td>
<!--                    <td :title="item.role" class="NoWrap">{{item.openId}}</td>-->
                  </tr>
                  </tbody>
                </table>
              </div>
              <page v-if="totalPage !== 0" :needPageSize="true" :pageSize="postDataEmp.PageSize" :totalCount="totalCount" v-on:on-getList="getList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
            </div>
          </div>
        </div>
        <div style="display: inline-block;vertical-align: top;width:255px;margin-top: -26px;">
          <div style="padding-left: 20px;color: #666" class="f_w">已选人员：{{chooseUserList.length}}</div>
          <div style="height: 600px;overflow: auto;margin: 10px;padding:10px;border: 1px solid #eee;border-radius: 10px;">
            <div :title="item.name" class="allSelectedMember" :key="index" v-for="(item, index) in chooseUserList">{{item.email ? '员工' : 'HCP'}} | {{item.name}} <b @click="removeSelect(item.openId)">X</b> </div>
          </div>
        </div>
      </div>
    </div>
    <div class="t_r w100">
      <button class="redButton" style="margin: 20px 20px 0 0" @click="sendMsg">发送</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'messagePushing',
  data () {
    return {
      selectAll: false,
      isHCP: true,
      pickerModel: 'wechatUser',
      totalPage: 1,
      totalCount: 0,
      page: 1,
      originUserList: [],
      userList: [],
      chooseUserList: [],
      chooseUserIdList: [],
      chooseIdList: [],
      searchCate: [
        {
          id: '',
          name: '全部',
          productName: '全部'
        },
        {
          id: '1',
          name: '2',
          productName: '2'
        }],
      departList: [],
      fieldsList: [],
      indicationsList: [],
      postData: {
        dept: '',
        PageIndex: 1,
        PageSize: 1000,
        name: '',
        email: '',
        ProfTitle: '',
        IsKOL: '',
        isRz: '',
        isFollewd: '',
        company_Name: '',
        location: '',
        building_Long: '',
        org_Acronym: '',
        IsAttention: '1',
        beginSubTime: '',
        endSubTime: '',
        beginRegTime: '',
        endRegTime: '',
        FieldId: '',
        IndicationId: ''
      },
      postDataEmp: {
        keywords: '',
        pageIndex: 1,
        pageSize: 1000
      },
      roleData: '',
      userData: {
        userName: '',
        userId: '',
        email: ''
      },
      modelDetail: [],
      messageList: [],
      postMessageModel: {
        from: JSON.parse(window.localStorage.getItem('userInfo') || '{}').email,
        openIds: [
        ],
        items: [
        ],
        url: '',
        templateId: '',
        researchId: ''
      },
      isLimitCheck: false,
      haveDomeSurveyList: [],
      selectedMuban: {}
    }
  },
  created () {
    if (this.isHCP) {
      this.getList(1)
      this.getDepart()
      // 获取领域
      this.getFieldsList()
      // 获取适应症
      this.getIndicationsList()
    } else {
      this.getAll(1)
    }
    this.getMessageList()
  },
  methods: {
    checkUrl(){
      if (this.selectedMuban.name === '问卷接收成功通知'){
        if (this.postMessageModel.url.indexOf('mobileSurvey?id=') > -1){
          let suveryID = this.$commonJs.getUrlParam('id', this.postMessageModel.url)
          this.isLimitCheck = true
          if (suveryID){
            // 搜索已接受过调研的用户信息
            this.$axiox.get(`/api/Research/GetOpenidsById/${suveryID}`).then( p => {
              this.haveDomeSurveyList = p || []
              this.haveDomeSurveyList.forEach( m => {
                this.chooseUserList.splice(this.chooseUserIdList.indexOf(m), 1)
                this.chooseUserIdList.splice(this.chooseUserIdList.indexOf(m), 1)
                this.chooseIdList.splice(this.chooseUserIdList.indexOf(m), 1)
                this.userList.forEach( n => {
                  if (n.openId === m){
                    n.checked = false
                  }
                } )
              } )

            } )
          } else {
            // 取消匹配信息
            this.isLimitCheck = false
            this.haveDomeSurveyList = []
          }
        } else {
          this.isLimitCheck = false
          this.haveDomeSurveyList = []
        }
      }

    },
    changeMuban (e) {
      console.log(e)
      this.selectedMuban = e
      this.postMessageModel.items = JSON.parse(JSON.stringify(e.items))
      if (e.name === '问卷接收成功通知'){
        this.checkUrl()
      } else {
        if (this.isLimitCheck){
          this.isLimitCheck = false
        }
      }
    },
    getMessageList () {
      this.$axiox.get('/api/MessageManagement/TemplateMessage/list').then(p => {
        this.messageList = p
        if (p[0]) {
          this.postMessageModel.items = JSON.parse(JSON.stringify(p[0].items))
          this.postMessageModel.templateId = p[0].templateId
        }
      })
    },
    switchHCP (value) {
      this.isHCP = value === 1
      if (value === 1) {
        this.getList(1)
      } else {
        this.getAll(1)
      }
    },
    // 发送
    sendMsg () {
      if (this.chooseUserIdList.length === 0) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请选择发送成员',
          stayTime: 5
        })
        return
      }
      let data = JSON.parse(JSON.stringify(this.postMessageModel))
      data.openIds = this.chooseUserIdList
      if (!this.isLimitCheck){
        delete data.researchId
      } else{
        data.researchId = Number(this.$commonJs.getUrlParam('id', this.postMessageModel.url))
      }
      this.$axiox.post('/api/MessageManagement/SendTemplateMessages', data).then(p => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '发送成功',
          stayTime: 5
        })
      })
    },
    // 员工
    getAll (PageNum) {
      this.postDataEmp.pageIndex = PageNum
      let url = this.$commonJs.returnQuery('/api/MessageManagement/GetEmployeeList', this.postDataEmp)
      this.$axiox.postForUser(url, this.postDataEmp).then(msg => {
        this.page = PageNum
        // console.log(msg)
        this.userList = msg.data
        this.totalPage = Math.ceil(msg.total / this.postDataEmp.pageSize)
        this.totalCount = msg.total
        let num = 0
        for (let i = 0; i < this.userList.length; i++) {
          if (this.chooseUserIdList.indexOf(this.userList[i].openId) >= 0) {
            this.$set(this.userList[i], 'checked', true)
          }
          if (this.userList[i].checked) {
            num++
          }
        }
        if (num === this.userList.length) {
          this.selectAll = true
        } else {
          this.selectAll = false
        }
      })
    },
    // HCP
    changeField () {
      this.postData.IndicationId = ''
      if (this.postData.FieldId) {
        let FieldId = (this.postData.FieldId.split(',')).map(item => Number(item))
        this.getIndicationsList(FieldId)
      } else {
        this.getIndicationsList()
      }
    },
    returnStr (arr) {
      let str = ''
      if (arr && arr.length > 0) {
        let newArr = arr.map(item => item.name)
        str = newArr.join(',')
      }
      return str
    },
    // 获取领域
    getFieldsList () {
      this.$axiox.get(`/api/Dict/GetFields`).then(res => {
        console.log(res, 'getFieldsList')
        let data = [{
          id: '',
          name: '全部'
        }]
        this.fieldsList = data.concat(res)
      })
    },
    // 获取适应症
    getIndicationsList (ids = []) {
      let params = ids
      this.$axiox.post(`/api/Dict/GetIndications`, params).then(res => {
        console.log(res, 'getIndicationsList')
        let data = [{
          fieldId: '',
          id: '',
          name: '全部'
        }]
        this.indicationsList = data.concat(res)
      })
    },
    getDepart (callback) {
      this.$axiox.get('/api/Dict/GetHosDepts').then(p => {
        for (let i = 0; i < p.length; i++) {
          p[i].nameId = p[i].description
        }
        this.departList = this.departList.concat(p)
        if (callback) {
          callback()
        }
      })
    },
    // 获取列表
    getList (pageIndex) {
      this.postData.PageIndex = pageIndex
      let data = JSON.parse(JSON.stringify(this.postData))
      data.endSubTime = data.endSubTime ? encodeURIComponent(data.endSubTime + ' 23:59:59') : ''
      data.endRegTime = data.endRegTime ? encodeURIComponent(data.endRegTime + ' 23:59:59') : ''
      if (data.IsKOL === '') {
        delete data['IsKOL']
      }
      if (data.isRz === '') {
        delete data['isRz']
      }
      if (data.isFollewd === '') {
        delete data['isFollewd']
      }
      console.log(data, 'data')
      console.log(this.postData, 'this.postData')
      let url = this.$commonJs.returnQuery('/api/MessageManagement/GetHcpList', data)
      this.$axiox.postForUser(url, data).then(msg => {
        console.log(msg, 'msg----')
        this.userList = msg.data
        this.originUserList = JSON.parse(JSON.stringify(msg.data))
        this.page = pageIndex
        this.totalPage = Math.ceil(msg.total / this.postData.PageSize)
        this.totalCount = msg.total
        let num = 0
        for (let i = 0; i < this.userList.length; i++) {
          if (this.chooseUserIdList.indexOf(this.userList[i].openId) >= 0) {
            this.$set(this.userList[i], 'checked', true)
          }
          if (this.userList[i].checked) {
            num++
          }
        }
        if (num === this.userList.length) {
          this.selectAll = true
        } else {
          this.selectAll = false
        }
        console.log(this.userTotalPage)
      })
    },
    // 选择用户
    chooseUserInfo (item) {
      if (this.isHCP) {
        if (item.checked) {
          if (this.chooseUserIdList.indexOf(item.openId) >= 0) {
          } else {
            this.chooseUserList.push(item)
            this.chooseUserIdList.push(item.openId)
            this.chooseIdList.push(item.openId)
          }
        } else {
          if (this.chooseUserIdList.indexOf(item.openId) >= 0) {
            this.chooseUserList.splice(this.chooseUserIdList.indexOf(item.openId), 1)
            this.chooseUserIdList.splice(this.chooseUserIdList.indexOf(item.openId), 1)
            this.chooseIdList.splice(this.chooseUserIdList.indexOf(item.openId), 1)
          } else {
          }
        }
      } else {
        if (item.checked) {
          if (this.chooseUserIdList.indexOf(item.openId) >= 0) {
          } else {
            this.chooseUserList.push(item)
            this.chooseUserIdList.push(item.openId)
            this.chooseIdList.push(item.openId)
          }
        } else {
          if (this.chooseUserIdList.indexOf(item.openId) >= 0) {
            this.chooseUserList.splice(this.chooseUserIdList.indexOf(item.openId), 1)
            this.chooseUserIdList.splice(this.chooseUserIdList.indexOf(item.openId), 1)
            this.chooseIdList.splice(this.chooseUserIdList.indexOf(item.openId), 1)
          } else {
          }
        }
      }
      if (this.chooseUserList.length === this.userList.length) {
        this.selectAll = true
      } else {
        this.selectAll = false
      }
      console.log('select-----++', this.chooseUserList, this.userList)
    },
    //  删除已选用户
    removeSelect (id) {
      this.chooseUserList.splice(this.chooseUserIdList.indexOf(id), 1)
      this.chooseIdList.splice(this.chooseUserIdList.indexOf(id), 1)
      this.chooseUserIdList.splice(this.chooseUserIdList.indexOf(id), 1)
      let num = 0
      for (let i = 0; i < this.userList.length; i++) {
        if (this.userList[i].openId === id) {
          this.$set(this.userList[i], 'checked', false)
        }
        if (this.userList[i].checked) {
          num++
        }
      }
      if (num === this.userList.length) {
        this.selectAll = true
      } else {
        this.selectAll = false
      }
    },
    // 选取所有人
    chooseAllData () {
      for (let i = 0; i < this.userList.length; i++) {
        if (this.isHCP) {
          if (this.selectAll) {
            // if (this.chooseUserIdList.indexOf(this.userList[i].openId) < 0) {
            if (this.chooseUserIdList.indexOf(this.userList[i].openId) < 0) {
              if (!this.isLimitCheck){
                this.$set(this.userList[i], 'checked', this.selectAll)
                this.chooseUserList.push(this.userList[i])
                this.chooseUserIdList.push(this.userList[i].openId)
                this.chooseIdList.push(this.userList[i].openId)
              } else {
                if (this.haveDomeSurveyList.indexOf(this.userList[i].openId) < 0){
                  this.$set(this.userList[i], 'checked', this.selectAll)
                  this.chooseUserList.push(this.userList[i])
                  this.chooseUserIdList.push(this.userList[i].openId)
                  this.chooseIdList.push(this.userList[i].openId)
                }
              }

            }
          } else {
            if (this.chooseUserIdList.indexOf(this.userList[i].openId) >= 0) {
              this.$set(this.userList[i], 'checked', this.selectAll)
              this.chooseUserList.splice(this.chooseUserIdList.indexOf(this.userList[i].openId), 1)
              this.chooseUserIdList.splice(this.chooseUserIdList.indexOf(this.userList[i].openId), 1)
              this.chooseIdList.splice(this.chooseUserIdList.indexOf(this.userList[i].openId), 1)
              i--
            }
          }
        } else {
          if (this.selectAll) {
            if (this.chooseUserIdList.indexOf(this.userList[i].openId) < 0) {
              if (!this.isLimitCheck){
                this.$set(this.userList[i], 'checked', this.selectAll)
                this.chooseUserList.push(this.userList[i])
                this.chooseUserIdList.push(this.userList[i].openId)
                this.chooseIdList.push(this.userList[i].openId)
              } else {
                if (this.haveDomeSurveyList.indexOf(this.userList[i].openId) < 0){
                  this.$set(this.userList[i], 'checked', this.selectAll)
                  this.chooseUserList.push(this.userList[i])
                  this.chooseUserIdList.push(this.userList[i].openId)
                  this.chooseIdList.push(this.userList[i].openId)
                }
              }
            }
          } else {
            if (this.chooseUserIdList.indexOf(this.userList[i].openId) >= 0) {
              this.$set(this.userList[i], 'checked', this.selectAll)
              this.chooseUserList.splice(this.chooseUserIdList.indexOf(this.userList[i].openId), 1)
              this.chooseUserIdList.splice(this.chooseUserIdList.indexOf(this.userList[i].openId), 1)
              this.chooseIdList.splice(this.chooseUserIdList.indexOf(this.userList[i].openId), 1)
              i--
            }
          }
        }
      }
      console.log('chooseUserList--', this.chooseUserList)
    }
  }
}
</script>

<style scoped>
.allSelectedMember{
  padding: 10px 20px;
  border-radius: 10px;
  background: #FEF5F0;
  margin: 10px 0;
  overflow: hidden;
  position: relative;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.allSelectedMember b{
  position: absolute;
  right: 10px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/messageManager/messagePushing.vue